/*eslint-disable*/
import PropTypes from "prop-types";
import React from "react";
import { Component } from "react";

import ChatActions from "../../actions/ChatActions";
import { RerouteProvider } from "./RerouteContext";

export default class Main extends Component {
    constructor() {
        super();

        ChatActions.auth();
    }

    render() {
        return <RerouteProvider>{this.props.children}</RerouteProvider>;
    }
}

Main.propTypes = {
    children: PropTypes.element.isRequired,
};
